import React from 'react';
import { Card, Table, Progress } from 'antd';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerBottlenecks } from '@/hooks/useManufacturingControlTower';

const BottleneckAnalyzer: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const { data, isLoading } = useControlTowerBottlenecks(filters);
  const rows = (data as { work_centers?: Record<string, unknown>[] })?.work_centers ?? [];
  const maxScore = Math.max(...rows.map((r) => Number(r.severity_score) || 1), 1);

  return (
    <Card id="bottlenecks" title="Bottleneck analyzer (work center queue)" style={{ marginTop: 16 }}>
      <Table
        size="small"
        loading={isLoading}
        rowKey="work_center"
        dataSource={rows}
        columns={[
          { title: 'Work center', dataIndex: 'work_center' },
          { title: 'Pending', dataIndex: 'pending_qty', width: 80 },
          { title: 'Inspection Q', dataIndex: 'inspection_queue', width: 100 },
          { title: 'Blocked', dataIndex: 'blocked_qty', width: 80 },
          { title: 'Delays', dataIndex: 'delay_count', width: 80 },
          {
            title: 'Severity',
            dataIndex: 'severity_score',
            render: (s: number) => (
              <Progress percent={Math.round((s / maxScore) * 100)} size="small" showInfo={false} />
            ),
          },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default BottleneckAnalyzer;
